import { defineStore } from 'pinia'
import axios from '@/tools/Axios/axios'
import * as Sentry from '@sentry/browser'
import { QuantityDiscount } from '@/interfaces/QuantityDiscount'

/**
 * Store guichet des regles de reduction quantitative actives sur
 * l'event courant (plan 039). Fetch une fois par event (au chargement
 * de l'event via EventStore). Utilise en aper�u client dans le
 * CartStore : la ligne "Remise appliquee" du recap panier est
 * derivee des regles + du contenu du panier.
 *
 * Le total definitif est celui renvoye par l'API sur le draft-order
 * (cf. CartStore.syncServerTotalSilently). Ce store sert uniquement
 * a montrer au vendeur la ligne de remise en amont de la creation
 * du draft.
 *
 * En cas d'echec du fetch, on retombe silencieusement sur un tableau
 * vide : le panier reste fonctionnel, l'aper�u remise ne s'affiche
 * simplement pas.
 */
export interface QuantityDiscountState {
    rules: QuantityDiscount[]
    isLoaded: boolean
}

export const useQuantityDiscountStore = defineStore('QuantityDiscountStore', {
    state: (): QuantityDiscountState => ({
        rules: [],
        isLoaded: false,
    }),
    actions: {
        async fetchActiveForEvent(eventId: string) {
            if (!eventId) return
            try {
                const { data } = await axios.get(
                    `/events/quantity-discounts/event/${eventId}/active`,
                    {
                        params: { channel: 'ticketOffice' },
                    },
                )
                this.rules = Array.isArray(data) ? data : []
                this.isLoaded = true
            } catch (error: any) {
                // Degradation douce : le guichet doit rester
                // fonctionnel meme si le fetch echoue.
                Sentry.captureException(error)
                this.rules = []
                this.isLoaded = true
            }
        },
        reset() {
            this.rules = []
            this.isLoaded = false
        },
    },
})
